import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { extractEnabledPermissions } from '../services/utils/extract-permissions';

export const useRBACStore = create(
  persist(
    (set, get) => ({
      currentProfile: {
          profileId: null,
          profileType: null,
          permissions: null, 
          orgId: null,
      },
      setCurrentProfile: async (profile) => {
        profile.permissions = extractEnabledPermissions(profile.permissions);
        set({ currentProfile: profile })
        return Promise.resolve(profile)
      },
    }),
    {
      name: 'rbac-storage',
      partialize: (state) => ({
        currentProfile: state.currentProfile,
      }),
    }
  )
);
